$(document).on('click', '#CartDrawer-Checkout', function(event) {
$(this).addClass('is-loading');
  $('#cart').submit();
});
  
$(document).on('click', '#pageheader .cart-link', function(event) {
  event.preventDefault(); 
 $('.cart-drawer').addClass('open_cartdrawer');
  $('body').addClass('js-drawer-open');
  $('.cart-overlay').show();
});
function drawerClose() {
  $('.cart-drawer').removeClass('open_cartdrawer');
  $('body').removeClass('js-drawer-open');
  $('.cart-overlay').hide();
  $('.PageOverlay').removeClass('is-visible');
  $('html').removeClass('no-scroll');
}

$(document).on("click", ".continue_shopping_button[type='button']", function (e) {
  e.preventDefault();
  $('.cart-drawer').removeClass('open_cartdrawer');
  $('body').removeClass('js-drawer-open');
  $('.cart-overlay').hide();
  $('.PageOverlay').removeClass('is-visible');
  $('html').removeClass('no-scroll');
});
$(document).on("click", ".cart-overlay", function (e) {
  e.preventDefault();
  $('.cart-drawer').removeClass('open_cartdrawer');
  $('body').removeClass('js-drawer-open');
  $(this).hide();
  $('.PageOverlay').removeClass('is-visible');
  $('html').removeClass('no-scroll');
});


$(document).on("click", '[data-action="close-drawer"]', function (e) {
// $('.utils__item.header-cart').click(function(e){
  e.preventDefault();
  $('.cart-drawer').removeClass('open_cartdrawer');
  $('body').removeClass('js-drawer-open');
  $('.cart-overlay').hide();
  $('.PageOverlay').removeClass('is-visible');
  $('html').removeClass('no-scroll');
});

function updateGiftInCart(cart) {
    let values = {};
    $('.gift_line').each(function () {
        let giftItemId = $(this).data('id');
        let isActive = $(this).hasClass('active');
        $.getJSON('/cart.js', function (cart) {
            let itemExistsInCart = cart.items.some(item => item.id === giftItemId);
            if (isActive && !itemExistsInCart) {
                values[giftItemId] = 1; 
            }
            else if (!isActive && itemExistsInCart) {
                values[giftItemId] = 0; 
            }
            console.log(values);
            if (Object.keys(values).length > 0) {
                $.ajax({
                    type: 'POST',
                    url: '/cart/update.js',
                    dataType: 'json',
                    data: { updates: values },
                    beforeSend: function (xhr) {
                        console.log('Updating cart...');
                    },
                    success: function () {
                        // Reload or update the cart view
                        carthtmldataGift(); 
                    },
                    error: function (xhr, status, error) {
                        console.error('Error updating cart:', error);
                    }
                });
            }
        });
    });
}

function carthtmldataGift(){
  $.ajax({
    type: 'GET', 
    url: '/',
    dataType: 'html',
    success: function(cart_html) {
      removeShippingProtction(cart);
      var cartdrawer_content = $(cart_html).find('#my-sidebar-cart').html();
      $('#my-sidebar-cart').html(cartdrawer_content);
      
      var cart_count = $(cart_html).find('#pageheader .cart-link .cart-link__count').html();
      $('#pageheader .cart-link .cart-link__count').html(cart_count);
      $('.cart-drawer').addClass('open_cartdrawer');
      $('body').addClass('js-drawer-open');
      $('.cart-overlay').show();
       $('.cart-value').removeClass('ready');
      $('.cart__loading .loading__spinner').addClass('hidden');
    }
  });
}

function addShippingProtection(data) {
 // $.getJSON('/cart.js', function(fetchedCart) {
 //    console.log(fetchedCart.item_count); 
 // let itemExistsInCart = fetchedCart.items.some(item => item.id === 42965451473075);
  //  console.log($('#shipping_protection_toggle').prop('checked') );
  //    if(!itemExistsInCart && fetchedCart.item_count > 0){

  const shipping_protection_toggle = $('#my-sidebar-cart .cart-value').attr('data-shippng');
 // console.log(shipping_protection_toggle);
 if(shipping_protection_toggle == "true"){
    var varintid = 42965451473075;
        fetch('/cart/add', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: varintid,
              quantity: 1,
              properties:{ "shipping-protection": "true" }
            }
          ],
          sections: "custom-cart-drawer"
        })
      })
      .then(response => response.json())
      .then(cart => {
        console.log('Success:', cart);
        const html = new DOMParser().parseFromString(cart.sections['custom-cart-drawer'], 'text/html');
        $('#my-sidebar-cart').html($(html).find('#my-sidebar-cart').html());
            $('#pageheader .cart-link__count').html(cart.item_count);
      
      $('.cart-drawer').addClass('open_cartdrawer');
      $('body').addClass('js-drawer-open');
      $('.cart-overlay').show();
       $('.cart-value').removeClass('ready');
       $('.cart__loading .loading__spinner').addClass('hidden');
      $('.upsell_loader .loading__spinner').addClass('hidden');
        updateGiftInCart(cart);
      })
      .catch(error => {
        console.error('Error:', error);
      });
    }else{
          carthtmldata(data);
    
}
  //  });
}
function loadaddShippingProtection(data) {
    const shipping_protection_toggle = $('#my-sidebar-cart .cart-value').attr('data-shippng');
 if(shipping_protection_toggle == "true"){
    var varintid = 42965451473075;
        fetch('/cart/add', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: varintid,
              quantity: 1,
              properties:{ "shipping-protection": "true" }
            }
          ],
          sections: "custom-cart-drawer"
        })
      })
      .then(response => response.json())
      .then(cart => {
        console.log('Success:', cart);
        const html = new DOMParser().parseFromString(cart.sections['custom-cart-drawer'], 'text/html');
        $('#my-sidebar-cart').html($(html).find('#my-sidebar-cart').html());
       $('#pageheader .cart-link__count').html(cart.item_count);
        updateGiftInCart(cart);
      })
      .catch(error => {
        console.error('Error:', error);
      });
    }
   // });
}
$( document ).ready(function() {
  loadaddShippingProtection();
});

function removeShippingProtction(data) {
    //let values = {};
     
        $.getJSON('/cart.js', function (fetchedCart) {
            let itemExistsInCart = fetchedCart.items.some(item => item.id === 42965451473075);
          
            console.log(itemExistsInCart);
          console.log(fetchedCart.item_count);
            if (itemExistsInCart && fetchedCart.item_count == 1) {
              console.log('if');
              $.ajax({
              type: "POST",
              url: '/cart/clear.js',
              data: '',
              dataType: 'json',
              success: function(cart) {
              console.log("clear.js loading successful");
                carthtmldata(cart);
              },
              error: function(XMLHttpRequest, textStatus) {
              console.log("clear.js loading failed");
              }
              });
            }
        });
}

function carthtmldata(oldCart){
  $.ajax({
    type: 'GET', 
    url: '/',
    dataType: 'html',
    success: function(cart_html) {

      var cartdrawer_content = $(cart_html).find('#my-sidebar-cart').html();
      $('#my-sidebar-cart').html(cartdrawer_content);
      var cart_count = $(cart_html).find('#pageheader .cart-link__count').html();
      console.log(cart_count);
      $('#pageheader .cart-link__count').html(cart_count);
      $('.cart-drawer').addClass('open_cartdrawer');
      $('body').addClass('js-drawer-open');
      $('.cart-overlay').show();
       $('.cart-value').removeClass('ready');
       $('.cart__loading .loading__spinner').addClass('hidden');
      $('.upsell_loader .loading__spinner').addClass('hidden');
        updateGiftInCart(cart_html);
    }
  });
}



function cartChange(line, qty){
fetch('/cart/change', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  body: JSON.stringify({
    line: line,
    quantity: qty,
    sections: ["custom-cart-drawer"]
  })
})
.then(response => response.json())
.then(cart => {
  console.log('Success:', cart);
  const html = new DOMParser().parseFromString(cart.sections['custom-cart-drawer'], 'text/html');
  $('#my-sidebar-cart').html($(html).find('#my-sidebar-cart').html());
  $('#pageheader .cart-link__count').html(cart.item_count);
  updateGiftInCart(cart);
  removeShippingProtction(cart);
})
.catch(error => {
  console.error('Error:',error);
});
}
function qunatityChange(cart_item, cart_varid){
  $.ajax({
    type: 'POST', 
    url: '/cart/change.js',
    dataType: 'json', 
    data : {
      "quantity": cart_item,
      "id": cart_varid,
    },
    success: function(data) {
      carthtmldata();
    }
  });
}

function addToCart(data){
fetch('/cart/add', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  body: data
})
.then(response => response.json())
.then(cart => {
  console.log('Success:', cart);
  const html = new DOMParser().parseFromString(cart.sections['custom-cart-drawer'], 'text/html');
  $('#my-sidebar-cart').html($(html).find('#my-sidebar-cart').html());
  $('#pageheader .cart-link__count').html(cart.item_count);
  updateGiftInCart(cart);
})
.catch(error => {
  console.error('Error:',error);
});
}



$(document).on('click', '.upsell-btn', function(event){
  event.preventDefault();
  $(this).parents('.pro-list-content').find('.upsell_loader .loading__spinner').removeClass('hidden');
   var id = $(this).parents('.pro-list-content').find('[name="id"]').val();
    var data = JSON.stringify({
        items: [
          {
            id: id,
            quantity: 1
          }
        ],
        sections: "custom-cart-drawer"
      });
    addToCart(data);
});



function drawerPlus(item) {
   $('.cart-value').addClass('ready');
 $('.cart__loading .loading__spinner').removeClass('hidden');
  var qty = parseInt($(item).prev().val());
  var line = $(item).attr('data-index');
  qty += 1;
  cartChange(line, qty);
}
function drawerMinus(item) {
   $('.cart-value').addClass('ready');
   $('.cart__loading .loading__spinner').removeClass('hidden');
 var qty = parseInt($(item).next().val());
  var line = $(item).attr('data-index');
  qty -= 1;
  cartChange(line, qty);
}
function drawerInputitem(item) {
   $('.cart-value').addClass('ready');
  $('.cart__loading .loading__spinner').removeClass('hidden');
  var qty = parseInt($(item).val());
  var line = $(item).attr('data-index');
  cartChange(line, qty);
}
function drawerRemove(item) {
   $('.cart-value').addClass('ready');
$('.cart__loading .loading__spinner').removeClass('hidden');
  var line = $(item).attr('data-index');
    cartChange(line, 0);
}

$(document).on('click', '#shipping_protection_toggle', function(event){
  //event.preventDefault();
  $(this).parents('.shipping_protection_outer').find('.shipping_protection_inactive').removeClass('.active_text');
      $(this).parents('.shipping_protection_outer').find('.shipping_protection_active').addClass('.active_text');
        
  var varintid = $(this).attr("data-variant");
    if($(this).prop('checked') == true){
        fetch('/cart/add', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: varintid,
              quantity: 1,
              properties:{ "shipping-protection": "true" }
            }
          ],
          sections: "custom-cart-drawer"
        })
      })
      .then(response => response.json())
      .then(cart => {
        console.log('Success:', cart);
        const html = new DOMParser().parseFromString(cart.sections['custom-cart-drawer'], 'text/html');
        $('#my-sidebar-cart').html($(html).find('#my-sidebar-cart').html());
            $('.cart-link__count').html(cart.item_count);
        updateGiftInCart(cart);
      })
      .catch(error => {
        console.error('Error:', error);
      });
    } else {
         //$(this).prop('checked',true);
        //alert("not checked");
      $(this).parents('.shipping_protection_outer').find('.shipping_protection_active').removeClass('.active_text');
      $(this).parents('.shipping_protection_outer').find('.shipping_protection_inactive').addClass('.active_text');
            fetch('/cart/change', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: varintid,
          quantity: 0,
          sections: ["custom-cart-drawer"]
        })
      })
      .then(response => response.json())
      .then(cart => {
        console.log('Success:', cart);
      const html = new DOMParser().parseFromString(cart.sections['custom-cart-drawer'], 'text/html');
      $('#my-sidebar-cart').html($(html).find('#my-sidebar-cart').html());
        $('.cart-link__count').html(cart.item_count);
        updateGiftInCart(cart);
      })
      .catch(error => {
        console.error('Error:',error);
      });
}
});


$(document).on('click', '.upsell_details_btn', function(event){
  event.preventDefault();
var up_product = $(this).attr('data-uproduct');
  $('.drawer_arrow_btn').css('opacity','1');
  $('.drawer__scrollable').addClass('drawer_upsell_scroll');
  
  $('#upselldetail_product_details').attr("style", "");
  $('#upselldetail_product_details .upselldetail_product_container').each(function(){
    var up_detailsproduct = $(this).attr('data-product');
    if(up_product == up_detailsproduct){
      $(this).show();
    }else{
      $(this).hide();
    }
  });
});
$(document).on('click', '.drawer_arrow_btn', function(event){
  event.preventDefault();
  $('.drawer_arrow_btn').css('opacity','0');
  $('.drawer__scrollable').removeClass('drawer_upsell_scroll');
  $('#upselldetail_product_details .upselldetail_product_container').hide();
  $('#upselldetail_product_details').attr("style", "max-height: calc(-145px + 100vh);");
});


// /* global SideDrawer */

// class CartDrawer extends SideDrawer {
//   connectedCallback() {
//     this.bindEvents();
//   }

//   bindEvents() {
//     this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
//     this.closeDrawerViaEventHandler = this.close.bind(this, null);
//     document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
//     document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
//     document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
//     this.addEventListener('on:cart-drawer:before-open', () => {
//       theme.manuallyLoadImages(this);
//       this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
//     });
//     this.addEventListener('on:cart:after-merge', () => {
//       theme.manuallyLoadImages(this);
//       this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
//     });
//   }

//   disconnectedCallback() {
//     document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
//     document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
//     document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
//   }

//   /**
//    * Handle when the drawer is opened via an event
//    * @param {object} evt - Event object.
//    */
//   handleDrawerOpenViaEvent(evt) {
//     this.open(evt.detail ? evt.detail.opener : null);
//   }

//   /**
//    * Trigger refresh of contents
//    */
//   cartRefreshHandler() {
//     this.querySelector('cart-form').refresh();
//   }

//   /**
//    * Update section's cart-form element with new contents
//    * @param {string} html - Whole-section HTML.
//    */
//   updateFromCartChange(html) {
//     this.querySelector('cart-form').refreshFromHtml(html);
    
//   }
// }

// window.customElements.define('cart-drawer', CartDrawer);
